import PropTypes from 'prop-types';
import { getConfig } from '@edx/frontend-platform';
import { ModalDialog } from '@openedx/paragon';

const LMS_ORG = 'lms';

// course-v1:ORG+COURSE+RUN -> ORG
export const getOrgFromCourseId = (courseId) => {
  const match = /^course-v1:([^+]+)\+/.exec(courseId || '');
  return match ? match[1].toLowerCase() : null;
};

/**
 * LMS-org courses must only be opened on the LMS microsite (apps.<MICROSITE_HOST>).
 * On any other host we show a blocking pop-up pointing to the microsite course.
 * Fails open if MICROSITE_HOST is not configured.
 */
export const getLmsCourseRedirect = (courseId, hostname = window.location.hostname) => {
  if (getOrgFromCourseId(courseId) !== LMS_ORG) { return null; }

  const micrositeHost = getConfig().MICROSITE_HOST;
  if (!micrositeHost) { return null; }

  let micrositeHostname;
  try {
    micrositeHostname = new URL(micrositeHost).hostname.toLowerCase();
  } catch (e) {
    return null;
  }

  const currentHost = hostname.toLowerCase();
  if (currentHost === micrositeHostname || currentHost === `apps.${micrositeHostname}`) {
    return null;
  }
  return `${micrositeHost.replace(/\/$/, '')}/courses/${courseId}/about`;
};

const LmsCourseBlock = ({ redirectUrl }) => (
  <ModalDialog
    title="Micro-Degree Course"
    isOpen
    onClose={() => {}}
    isBlocking
    hasCloseButton={false}
    isOverflowVisible={false}
  >
    <ModalDialog.Body className="text-center py-4">
      <h2 className="h4 mb-4">
        This course is offered as a Micro-Degree or a module in our study programs on the German UDS LMS.
      </h2>
      <a href={redirectUrl} className="font-weight-bold">Click here to go to this course.</a>
    </ModalDialog.Body>
  </ModalDialog>
);

LmsCourseBlock.propTypes = {
  redirectUrl: PropTypes.string.isRequired,
};

export default LmsCourseBlock;
